var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplitArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "none",
    stroke: "none",
    d: "M 0 0 L 24 0 L 24 24 L 0 24 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ffffff",
    stroke: "none",
    d: "M 5.83 12 L 9 8.83 L 7.59 7.42 L 3 12 L 7.59 16.59 L 9 15.17 L 5.83 12 Z M 18.17 12 L 15 15.17 L 16.41 16.58 L 21 12 L 16.41 7.41 L 15 8.83 L 18.17 12 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitArrows);
export default __webpack_public_path__ + "static/media/split-arrows.8666603a7beb8f7f85351815fac0d6f5.svg";
export { ForwardRef as ReactComponent };